import styled from 'styled-components';

export const VideoLoadingPlaceholder = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    gap: 16px;
    background-color: rgba(67, 89, 112, 0.8);
    opacity: ${(props) => (props.visible ? 1 : 0)};
    z-index: ${(props) => (props.visible ? 5 : -5)};
    transition: 0.3s all ease-in-out;
`;

export const SlowLoadingHint = styled.p`
    color: #fff;
    font-size: 16px;
    line-height: 1.4;
    max-width: 420px;
    text-align: center;
    margin: 0;
    padding: 0 16px;
`;

export const PreloadErrorContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(67, 89, 112, 0.95);
    padding: 24px;
    gap: 24px;
    z-index: 10;
`;

export const PreloadErrorMessage = styled.p`
    color: #fff;
    font-size: 18px;
    line-height: 1.5;
    max-width: 480px;
    text-align: center;
    margin: 0;
`;

export const PreloadErrorButton = styled.button`
    padding: 12px 32px;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    background-color: #2563eb;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #1d4ed8;
    }
`;